/**
 * Zentrale Helfer für Monats-Schlüssel im Format "YYYY-MM".
 *
 * Vorher waren diese Funktionen wortgleich in ShiftsPage und CalendarPage
 * dupliziert. Jetzt einmal hier — Grundlage für den geteilten Zeitraum-Store
 * (store/period.ts), damit Liste, Kalender und Übersicht denselben Monat teilen.
 */

export const MONTHS_DE = [
  'Januar', 'Februar', 'März', 'April', 'Mai', 'Juni',
  'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember',
] as const;

/** Aktueller Monat als "YYYY-MM" (lokale Zeit). */
export function currentMonthKey(): string {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

/** Verschiebt einen Monats-Schlüssel um `delta` Monate (in UTC gerechnet). */
export function shiftMonthKey(key: string, delta: number): string {
  const [y, m] = key.split('-').map(Number);
  const d = new Date(Date.UTC(y!, (m ?? 1) - 1 + delta, 1));
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
}

/** Lesbares Label, z. B. "Mai 2026". */
export function monthLabel(key: string): string {
  const [y, m] = key.split('-').map(Number);
  return `${MONTHS_DE[(m ?? 1) - 1]} ${y}`;
}
